import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as UnsubscribeIcon } from '../../../../assets/icons/subscriptions/unsubscribe.svg';
import AppButton from '../app-button/AppButton';
import { mergeSubscriptionButtonSx } from './subscriptionIconOnlyButtonSx';

type AppButtonProps = React.ComponentProps<typeof AppButton>;

export type ICancelSubscriptionRequestButtonProps = Omit<
  AppButtonProps,
  'children' | 'variant' | 'icon' | 'startIcon'
> & {
  iconOnly?: boolean;
};

export function CancelSubscriptionRequestButton(
  props: ICancelSubscriptionRequestButtonProps,
) {
  const { loading, iconOnly, sx, ...rest } = props;
  const { t } = useTranslation();
  const label = t('common.cancelRequest');

  return (
    <AppButton
      {...rest}
      sx={mergeSubscriptionButtonSx(iconOnly, sx)}
      loading={loading}
      variant="outlined"
      icon={<UnsubscribeIcon />}
      aria-label={iconOnly ? label : undefined}>
      {iconOnly ? null : label}
    </AppButton>
  );
}
